/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { GetGlycerinArticleIdFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetGlycerinArticleIdFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const getGlycerinArticleIdDataMock: GetGlycerinArticleIdFragmentFragment = {
  orderNumber: '7353915',
  promotion: '009',
};

export function getGetGlycerinArticleIdFragmentedData(data?: GetGlycerinArticleIdFragmentFragment) {
  return makeFragmentData(
    data || getGlycerinArticleIdDataMock,
    GetGlycerinArticleIdFragmentFragmentDoc,
  );
}
